// src/util/date-util.js

/**
 * Formatea una fecha en formato DD-MM-YYYY (zona horaria local: Lima, Perú).
 *
 * @param {string|Date|null} value
 * @returns {string}
 */
export function formatDate(value) {
  if (!value) return "-";

  const date = new Date(value);

  const local = date.toLocaleDateString("es-PE", {
    timeZone: "America/Lima",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  // Ejemplo: "05/11/2025" -> "05-11-2025"
  return local.replace(/\//g, "-");
}

/**
 * Formatea fecha y hora: DD-MM-YYYY HH:mm (zona horaria Lima)
 */
export function formatDateTime(value) {
  if (!value) return "-";

  const date = new Date(value);
  if (isNaN(date.getTime())) return "-";

  const local = date.toLocaleString("es-PE", {
    timeZone: "America/Lima",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false, // formato 24h
  });

  // Ejemplo: "05/11/2025 14:35" -> "05-11-2025 14:35"
  return local.replace(/\//g, "-");
}

/**
 * Solo la hora local (HH:mm)
 */
export function formatOnlyTime(value) {
  if (!value) return "-";

  const date = new Date(value);
  if (isNaN(date.getTime())) return "";

  return date.toLocaleTimeString("es-PE", {
    timeZone: "America/Lima",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}



// WEBPACK FOOTER //
// ./src/util/date-util.js